import React, { useEffect, useState } from 'react';
import { string, number, oneOfType, bool, node } from 'prop-types';
import AiOutlineMinus from '../icons/AiOutlineMinus';
import AiOutlinePlus from '../icons/AiOutlinePlus';

// eslint-disable-next-line react/prop-types
const FooterItemBlock = ({ blockTitle, children, blockWidth, isMobile }) => {
    const [expanded, setExpanded] = useState(true);

    useEffect(() => {
        if (!isMobile) {
            setExpanded(true);
        }
    }, [isMobile]);

    const handleClick = (e) => {
        if (!isMobile) 
            return;
        setExpanded(!expanded);
    };

    return (<div
        className={'footer-item-block'}
        style={{ ...(!isMobile) ? ({ width: `calc(${blockWidth}% - 1rem)` }) : ({ width: '100%' }) }}>
        <h2
            className={'footer-block-title'}
            onClick={handleClick}>
            {blockTitle !== '' && blockTitle}
            {isMobile === true && (<>
                {expanded === false && (<AiOutlinePlus
                    size={'25px'} />)}
                {expanded === true && (<AiOutlineMinus
                    size={'25px'} />)}
            </>)}
        </h2>
        <div
            className={'footer-block-content'}
            style={{
                ...isMobile === true && ({
                    maxHeight: `${!expanded ? '0' : '1000px'}`,
                    borderBottom: '1px solid rgba(0, 0, 0, .5)',
                    ...expanded === true && ({
                        paddingBottom: '25px',
                    }),
                })
            }}
        >
            {children}
        </div>
    </div>);
};

FooterItemBlock.propTypes = {
    blockTitle: string,
    children: node,
    blockWidth: oneOfType([number, string]),
    isMobile: bool,
};

FooterItemBlock.defaultProps = {
    blockTitle: '',
};

export default FooterItemBlock;